import Stores from '@/components/stores/Stores'
import StoresNew from '@/components/stores/StoresNew'
import StoresEdit from '@/components/stores/StoresEdit'
export default [
  {
    path: '/stores',
    name: 'stores',
    component: Stores,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stores/new',
    name: 'storesNew',
    component: StoresNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stores/:id/edit',
    name: 'storesEdit',
    component: StoresEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/storesRoutes.js